"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectsSink = void 0;
const icons_1 = require("client/components/icons");
const autocomplete_1 = require("client/components/material/autocomplete");
const select_1 = require("client/components/material/select");
const multi_select_1 = require("client/components/ui/multi-select");
const select_2 = require("client/components/ui/select");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
require("./selects.less");
const data = ramda_1.range(1, 10).map(i => ({
    id: i,
    label: `Someone ${i}`,
    value: i.toString(),
    icon: React.createElement(icons_1.SitesIcon, null)
}));
const statesStr = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];
const states = statesStr.sort().map((state, i) => ({
    id: i,
    label: state,
    value: state
}));
let SelectsSink = class SelectsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.selectedItem = "";
        this.multiSelections = [];
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("div", { className: "selects" },
                React.createElement("h2", null, "Selects"),
                React.createElement(select_2.UiSelect, { label: "Search", options: data, value: this.selectedItem, onSelect: item => {
                        this.selectedItem = item;
                    } }),
                React.createElement("h2", null, "MultiSelect"),
                React.createElement(multi_select_1.UiMultiSelect, { label: "Default ICD 10s", options: data, values: this.multiSelections, onChange: values => (this.multiSelections = values) })),
            React.createElement("h2", null, "Material Select"),
            React.createElement("div", { className: "material-selects" },
                React.createElement(autocomplete_1.MaterialAutocomplete, { placeholder: "Country" }),
                React.createElement(autocomplete_1.MaterialAutocomplete, { pillbox: true, placeholder: "Countries" }),
                React.createElement(autocomplete_1.MaterialAutocomplete, { pillbox: true, placeholder: "Countries", searchable: false }),
                React.createElement(select_1.MaterialSelect, { placeholder: "Country", label: "State", options: states, value: "" }))));
    }
};
__decorate([
    mobx_1.observable
], SelectsSink.prototype, "selectedItem", void 0);
__decorate([
    mobx_1.observable
], SelectsSink.prototype, "multiSelections", void 0);
SelectsSink = __decorate([
    mobx_react_1.observer
], SelectsSink);
exports.SelectsSink = SelectsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/selects/selects.tsx
// module id = 3659
// module chunks = 0